import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { useModal } from "@/modals"
import { useAppSelector } from "@/store"
import { useMatchResignMutation } from "@/store/apis/matchAPI"
import { GameplaySelectors } from "@/store/slices/gameplay"
import { Button } from "@/ui/Button"
import { Modal } from "@/ui/Modal"
import { OutlinedText } from "@/ui/OutlinedText"
import styles from "./MatchSurrenderModal.module.scss"

const modalType = "matchSurrender"

export const MatchSurrenderModal: FC = () => {
  const { modal, getModalParams } = useModal(modalType)
  const sessionId = useAppSelector(GameplaySelectors.selectSessionId())
  const { t } = useTranslation()

  const params = getModalParams(modalType)

  const [matchResign, { isLoading: isMatchResignLoading }] =
    useMatchResignMutation()

  const handleSurrender = async () => {
    await matchResign(sessionId ?? "").then(() => {
      handleClose()
    })
  }

  const handleBack = () => {
    params?.onBack?.()
    modal.close()
  }

  const handleClose = () => {
    modal.close()
  }

  return (
    <Modal.Center
      type={modalType}
      className={clsx(styles.MatchSurrenderModal)}
      body={{ className: styles.MatchSurrenderModal_body }}
    >
      <Modal.StoneFlexContainer
        className={styles.MatchSurrenderModal_container}
        content={{ className: styles.MatchSurrenderModal_content }}
        outside={
          <>
            <div className={clsx(styles.MatchSurrenderModal_footerButtons)}>
              {params?.onBack ? (
                <Button
                  className={clsx(
                    styles.MatchSurrenderModal_footerButtons_item
                  )}
                  styles="green"
                  onClick={handleBack}
                >
                  {t("button.back")}
                </Button>
              ) : (
                <Button
                  className={clsx(
                    styles.MatchSurrenderModal_footerButtons_item
                  )}
                  styles="green"
                  onClick={handleClose}
                >
                  {t("button.close")}
                </Button>
              )}
            </div>
          </>
        }
      >
        <OutlinedText className={clsx(styles.MatchSurrenderModal_title)}>
          {t("surrender.title")}
        </OutlinedText>
        <div className={clsx(styles.MatchSurrenderModal_text)}>
          {t("surrender.description")}
        </div>
        <Button
          className={clsx(styles.MatchSurrenderModal_button)}
          styles="red"
          isLoading={isMatchResignLoading}
          onClick={handleSurrender}
        >
          {t("surrender.title")}
        </Button>
      </Modal.StoneFlexContainer>
    </Modal.Center>
  )
}
